export default {
  getPlaceByID: (state) => (inputValue) => {
    return state.locations.filter(location => {
      var userNameResult = null
      var phoneNumberResult = null
      var locationAddressResult = null
      if (location.userName !== null) {
        userNameResult = location.userName.match(inputValue)
      }
      if (location.phoneNumber !== null) {
        phoneNumberResult = location.phoneNumber.match(inputValue)
      }
      if (location.locationAddress !== null) {
        locationAddressResult = location.locationAddress.match(inputValue)
      }
      if (userNameResult !== null || phoneNumberResult !== null || locationAddressResult !== null) {
        var result = location.userName + location.phoneNumber + location.locationAddress
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/placeModules/getters.js